import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "./AuthShell";
import { useAuth } from "@/lib/auth";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate();
    const { verifyEmail, getErrorMessage } = useAuth();
    
    const [status, setStatus] = useState("verifying"); // verifying, success, error
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setErrorMsg("No verification token provided.");
            return;
        }

        const verify = async () => {
            try {
                await verifyEmail(token);
                setStatus("success");
                toast.success("Email verified successfully!");
                setTimeout(() => {
                    navigate("/dashboard", { replace: true });
                }, 1500);
            } catch (err) {
                setStatus("error");
                setErrorMsg(getErrorMessage(err));
            }
        };

        verify();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <AuthShell title="Verifying your email" subtitle="Please wait a moment...">
            <div className="text-center py-8">
                {status === "verifying" && (
                    <div className="flex flex-col items-center gap-4">
                        <Loader2 className="animate-spin text-ink w-10 h-10" />
                        <p className="text-[15px] font-medium text-ink-muted">Verifying your account...</p>
                    </div>
                )}
                {status === "success" && (
                    <div className="flex flex-col items-center gap-4">
                        <CheckCircle2 className="text-mint w-12 h-12" />
                        <p className="text-[15px] font-semibold text-ink">Success! Redirecting you to the dashboard...</p>
                    </div>
                )}
                {status === "error" && (
                    <div className="flex flex-col items-center gap-4">
                        <XCircle className="text-coral w-12 h-12" />
                        <p className="text-[15px] font-semibold text-coral">{errorMsg}</p>
                        <button
                            onClick={() => navigate("/login")}
                            className="mt-4 bg-ink hover:bg-coral text-cream-100 rounded-full py-2.5 px-6 text-[14.5px] font-semibold transition-all"
                        >
                            Go to Sign In
                        </button>
                    </div>
                )}
            </div>
        </AuthShell>
    );
}
